function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { SimpleEventEmitter } from "@sail/utils";
export default function createCookieEventListener(stripeCookie, reports) {
    const simpleEventEmitter = new SimpleEventEmitter();
    var _Object_getOwnPropertyDescriptor;
    const descriptor = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie')) !== null && _Object_getOwnPropertyDescriptor !== void 0 ? _Object_getOwnPropertyDescriptor : Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
    if (descriptor && descriptor.configurable) {
        Object.defineProperty(document, 'cookie', _object_spread_props(_object_spread({}, descriptor), {
            set: (value)=>{
                var _descriptor_set;
                (_descriptor_set = descriptor.set) === null || _descriptor_set === void 0 ? void 0 : _descriptor_set.call(document, value);
                const [cookieName] = value.split('=');
                const cookieValue = stripeCookie.get(cookieName);
                simpleEventEmitter.notify(cookieValue == null ? {
                    type: 'remove',
                    name: cookieName
                } : {
                    type: 'set',
                    name: cookieName,
                    value: cookieValue
                });
            }
        }));
    } else {
        reports.warning(`Cannot patch cookie event listeners, descriptor is not configurable`, {
            project: 'sail_core'
        });
    }
    return simpleEventEmitter;
}

//# sourceMappingURL=createCookieEventListener.js.map